module.exports = __webpack_public_path__ + "img/ic_add_person.131ec9bc.svg";